
import Vue from "vue";
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import { IExcelMapperWrapper } from "@/utils/excel-mapper/excel-mapper-wrapper";

export default Vue.extend({
	data(){
		return {
			processing: false
		};
	},
	props: {
		value: {
			type: Object as ()=>IExcelMapperWrapper,
			required: true
		}
	},
	computed: {
		extensions():string[]{
			return ["xlsx", "xls", "csv"];
		},
		sheetTitle():string{
			if (!this.value.hasSheet) return "";
			let sheet = this.value.getSheet();
			if (!sheet) return "";
			return sheet.workbook.title;
		}
	},
	methods: {
		removeFile(){
			this.value.removeSheet();
		},
		async onFile(file:File){
			if (this.processing) return;
			try{
				console.log(file);
				this.processing = true;
				if (file.type == "text/plain" || file.type == "text/csv"){
					await this.value.readCsv(file);
				}else{
					await this.value.readExcel(file);
				}
			}catch(err){
				console.error(err);
				throw err;
			}finally{
				this.processing = false;
			}
		}
	},
	components: {
		AppFileUpload
	},
	i18nEx: {
		componentPrefix: "components.excel-mapper"
	}
});
